import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconBlogWizard = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 32 32"
    data-fill-none
  >
    <path
      d="M13.0004 25.25H7.24707C6.84925 25.25 6.46771 25.092 6.18641 24.8107C5.90511 24.5294 5.74707 24.1478 5.74707 23.75L5.74707 7.25C5.74707 6.85218 5.90511 6.47064 6.18641 6.18934C6.46771 5.90804 6.84925 5.75 7.24707 5.75L22.2471 5.75C22.6449 5.75 23.0264 5.90804 23.3077 6.18934C23.589 6.47064 23.7471 6.85218 23.7471 7.25L23.7471 13M13.2471 10.25L19.2471 10.25M10.2471 14.75L19.2471 14.75M10.2471 19.25H16.429"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6999 27.0431L15.5 27.5L15.9569 24.2966L24.1859 16.0676C24.3663 15.8875 24.5803 15.7447 24.8159 15.6473C25.0514 15.5499 25.3038 15.4998 25.5587 15.5C25.8135 15.5002 26.0659 15.5505 26.3013 15.6482C26.5367 15.7459 26.7506 15.889 26.9307 16.0693C27.1108 16.2497 27.2536 16.4637 27.351 16.6992C27.4484 16.9348 27.4984 17.1872 27.4983 17.442C27.4981 17.6969 27.4478 17.9493 27.3501 18.1847C27.2524 18.4201 27.1093 18.634 26.929 18.8141L18.6999 27.0431Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconBlogWizard.displayName = 'IconBlogWizard';
